module.exports = __webpack_public_path__ + "static/img/logo.523cda6f.png";